import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=699ac048&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699ac048",
  null
  
)

export default component.exports